<template>
  <div class="upload-item" :class="{ 'is-empty': isEmpty, disabled: disabled }" @click.capture="onInitUploader">

    <!-- 未选择内容 -->
    <div class="empty-view flex-center" v-show="isEmpty">
      <i class="loading-icon el-icon-loading" v-show="loading"/>
      <i class="add-icon el-icon-plus" v-show="!loading"/>
      <div class="hover-view flex-column-center" v-show="!loading">
        <div v-for="(name, i) of emptyActions" :key="i">
          <el-button class="upload-button" size="mini" v-show="name === 'upload'" ref="uploadButton" type="file">上传{{ typeName }}</el-button>
          <el-button class="capture-button" size="mini" @click.stop="onCaptureClick" v-show="name === 'capture'">选择抓取{{ typeName }}</el-button>
          <el-button class="link-button" size="mini" @click.stop="onLinkClick" v-show="name === 'link'">填写{{ typeName }}链接</el-button>
          
          <p class="text-center" v-if="emptyActions.length - 1 != i">—— 或 ——</p>
        </div>
      </div>
    </div>

    <!-- 已选择内容 -->
    <div class="source-view" v-show="!isEmpty">
      <img :src="src" v-if="isImage">
      <video preload controls v-if="isVideo&&videoBarRander">
        <source :src="src" type="video/mp4">
        <source :src="src" type="video/ogg">
        您的浏览器不支持 HTML5 video 标签。
      </video>
      <div class="hover-view flex-center">
        <template v-for="(name, i) of sourceActions">
          <i class="preview-icon el-icon-search" @click.stop="onPreviewClick" v-if="name === 'preview'" :key="i"/>
          <i class="delete-icon el-icon-delete" @click.stop="onDeleteClick" v-if="name === 'delete'" :key="i"/>
        </template>
      </div>

    </div>

  </div>
</template>

<script>
import plupload from 'plupload'
import typeMixin from './mixins/type'
import { API_URL } from '@/utils/request'
import { getToken, getRoles } from '@/utils/auth' // getToken from cookie
export default {
  name: 'CustomUploadItem',
  mixins: [ typeMixin ],
  props: {

    // 文件url
    src: { type: String },

    // 没有添加内容时，触发添加的操作方式
    emptyActions: { type: Array, default: () => [ 'upload', 'capture', 'link' ] },

    // 有内容时，堆内容的操作方式
    sourceActions: { type: Array, default: () => [ 'preview', 'delete' ] },

    // 多张图片
    multiple: { type: Boolean, default: false },

    disabled: Boolean,

    videoBarRander:Boolean,
  },
  data: () => ({
    loading: false,
    uploaderInstance: null, // 上传插件实例
    uploadQueued: 0,    // 上传队列数量
    uploadQueueList: [], // 已上传完毕的item
  }),

  computed: {
    isEmpty: (vm) => !vm.src,
  },

  watch: {
    multiple: {
      immediate: true,
      handler(val) {
        if (!this.uploaderInstance) return
        this.uploaderInstance.setOption({
          multi_selection: val,
        })
      },
    },
  },

  methods: {

    // 抓取图片
    onCaptureClick(e) {
      this.$emit('capture', e)
    },

    // 填写图片链接
    onLinkClick(e) {
      this.$emit('link', e)
    },

    // 点击预览
    onPreviewClick(e) {
      this.$emit('preview', e)
    },

    // 点击删除
    onDeleteClick(e) {
      this.$emit('delete', e)
    },

    // 初始化上传插件
    onInitUploader() {
      if (!this.$refs.uploadButton || this.uploaderInstance) return

      const role = getRoles()[0]
      
      const uploader = new plupload.Uploader({
        browse_button: this.$refs.uploadButton[0].$el,  // 触发文件选择对话框的按钮，为那个元素id
        url : `${ API_URL }?do=picture_add`, //服务器端的上传页面地址
        file_data_name: 'picture',
        multipart_params: {
          sid: getToken(),
          type: role === 'admin' ? role : 'taobaoke',
        },
        multi_selection: this.multiple,
      })
      uploader.init()
      uploader.bind('FilesAdded', (uploader) => {
        uploader.start()
        this.loading = true
      })
      uploader.bind('FileUploaded', (uploader, file, responseObject) => {
        const data = JSON.parse(responseObject.response);
        if(data.error_code == 0) {
          this.uploadQueueList.push(data.file)
          // 等队列处理完后再触发事件
          if (this.uploadQueueList.length === this.uploadQueued) {
            this.$emit('upload', this.uploadQueueList)
            this.uploadQueued = 0
            this.uploadQueueList = []
            this.loading = false
          }
        }
        else {
          this.$message.error(data.error_message)
          this.loading = false
        }
      })
      uploader.bind('QueueChanged', (uploader) => {
        // 记录上传列表剩下的上传数量
        this.uploadQueued = uploader.total.queued
      })
      
      uploader.bind('Error', (uploader, errObject) => {
        this.$message.error(errObject.message)
      })

      this.uploaderInstance = uploader

    },

  },

  mounted() {
    this.onInitUploader()
    console.log(this.videoBarRander)
  },

}
</script>

<style lang="scss" scoped>
.upload-item {
  width: 148px;
  height: 148px;
  background: #FFF;
  border: 1px solid #C1C9D2;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  vertical-align: middle;

  &.is-empty {
    border-style: dashed;
  }

  &.disabled {
    pointer-events: none;
    cursor: not-allowed;
  }
}

.empty-view {
  width: 100%;
  height: 100%;
  &:hover {
    .add-icon {
      opacity: 0;
      pointer-events: none;
    }
    .hover-view {
      opacity: 1;
      pointer-events: all;
    }
  }
  .add-icon, .loading-icon {
    font-size: 28px;
    color: #C1C9D2;
  }
}

.source-view {
  width: 100%;
  height: 100%;

  &:hover {
    .hover-view {
      opacity: 1;
      pointer-events: all;
    }
  }

  img, video {
    width: 100%;
    height: 100%;
    display: block;
  }

  .hover-view {
    background: rgba(#000, .5);
    i {
      cursor: pointer;
      margin: 0 4px;
    }
  }
}

.hover-view {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  font-size: 12px;
  color: #C1C9D2;
  opacity: 0;
  transition: all .3s;
  pointer-events: none;

  i {
    color: #FFF;
    font-size: 16px;
  }

  .el-button {
    background: #FFF;
    border: 1px solid #C1C9D2;
    font-size: 12px;
    color: #46494D;
    border-radius: 2px;
  }
  p {
    line-height: 1.6;
  }
}


.el-button+.el-button {
  margin: 0;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-column-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.text-center {
  text-align: center;
  
}

</style>